module.exports = __webpack_public_path__ + "img/filipe.cb27fdf3.jpeg";